import React from 'react'
import Fab from '@material-ui/core/Fab';
import MenuIcon from '@material-ui/icons/Menu';
import styles from './Navbar.module.css'
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Schedule from '@material-ui/icons/Schedule';
import Create from '@material-ui/icons/Create';
import ImportContacts from '@material-ui/icons/ImportContacts';
import Mood from '@material-ui/icons/Mood';
import MeetingRoom from '@material-ui/icons/MeetingRoom';
import { useHistory } from 'react-router-dom';
import Map from '@material-ui/icons/Map';
import Shared from '../services/Shared';

const ITEMS = [
        {
            icon: ImportContacts,
            name: "Catalog",
            path: Shared.path.catalog
        },
        {
            icon: Create,
            name: "Register",
            path: Shared.path.register
        },
        {
            icon: Schedule,
            name: "Schedule",
            path: Shared.path.schedule
        },
        {
            icon: Map,
            name: "Campus Map",
            path: Shared.path.map
        },
        {
            icon: Mood,
            name: "Faculty",
            path: Shared.path.faculty
        },
        {
            icon: MeetingRoom,
            name: "Log out",
            path: Shared.path.login
        }
    ]

export default function Navbar(props) {

    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

    const history = useHistory();

    function onItem(item) {

        if(item.name === "Log out") {
            Shared.removeSession();
        }

        history.push(item.path);
    }

    function onLogo(e) {
        history.push(Shared.path.menu);
    }

    function toggleDrawer() {
        setIsDrawerOpen(!isDrawerOpen);
    }

    return (
        <>
        <div className={styles.contain}>
            <div className={styles.navbar}>
                <div className={props.hideMenu ? styles.hide : ''}>
                    <Fab size="small" onClick={toggleDrawer}>
                        <MenuIcon />
                    </Fab>
                </div>
                <div className={styles.logoDiv}>
                    <div className={styles.ivyLeague}>Ivy League Canine Academy</div>
                    <div onClick={onLogo}><img className={styles.logo} alt='logo' src={Shared.assets + '/canine_u.png'}/></div>
                </div>

                <Drawer anchor={"left"} open={isDrawerOpen} onClose={toggleDrawer}>
                    <div className={styles.list} onClick={toggleDrawer}>
                        <List>
                            {ITEMS.map(item => {
                                // Uppercase so React knows it's a component
                                const IconComponent = item.icon;

                                return (
                                <ListItem button key={item.name} onClick={e => onItem(item)}>
                                    <ListItemIcon><IconComponent /></ListItemIcon>
                                    <ListItemText primary={item.name} />
                                </ListItem>)
                            })}
                        </List>
                    </div>
                </Drawer>
            </div>
        </div>
        <div className={styles.box}></div>
        </>
    )
}
